

import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="relative z-20 border-t border-gray-100 py-8 px-4 bg-white">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-4">
        <div className="flex items-center space-x-2">
          <div className="w-8 h-8 bg-gradient-to-br from-emerald-600 to-green-700 rounded-xl flex items-center justify-center shadow-sm">
            <svg width="16" height="16" viewBox="0 0 24 24" className="w-4 h-4">
              {/* Simple overlapping circles */}
              <circle cx="8" cy="8" r="4" fill="none" stroke="white" strokeWidth="1.5"/>
              <circle cx="16" cy="8" r="4" fill="none" stroke="white" strokeWidth="1.5"/>
              <circle cx="12" cy="16" r="4" fill="none" stroke="white" strokeWidth="1.5"/>
            </svg>
          </div>
          <span className="text-sm text-gray-500">
            © 2024 Gathur. All rights reserved.
          </span>
        </div>
        <div className="flex space-x-6">
          <Link 
            to="/privacy-policy" 
            className="text-gray-400 hover:text-green-500 transition cursor-pointer"
          >
            Privacy Policy
          </Link>
          <a 
            href="https://x.com/gathur_app" 
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-green-500 transition cursor-pointer"
          >
            Twitter
          </a>
          <a 
            href="https://www.instagram.com/gathur_app" 
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-green-500 transition cursor-pointer"
          >
            Instagram
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;